export const columnsDataComplex = [
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Amount",
    accessor: "amount",
  },
  {
    Header: "Payment Status",
    accessor: "paymentStatus",
  },
  {
    Header: "Process Status",
    accessor: "processStatus",
  },
  {
    Header: "PERIOD",
    accessor: "period",
  },
];
